import { render, staticRenderFns } from "./InvitesWizard.vue?vue&type=template&id=678fd827"
import script from "./InvitesWizard.vue?vue&type=script&lang=js"
export * from "./InvitesWizard.vue?vue&type=script&lang=js"
import style0 from "./InvitesWizard.vue?vue&type=style&index=0&id=678fd827&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports